import React from 'react';
import Text from '../../../shared/common/Text';
import { TextField } from '@material-ui/core';
import { CenterSearchMember, ContainerGroupsForm } from '../styled-components/groups.styled.components';

const GroupName = props => {
    const { nombre, handleName, placeholder } = props;

    // RETURN
    return (
        <ContainerGroupsForm>
            <Text fontSize="1rem" fontWeight="700" color="primary">
                Nombre del grupo
            </Text>
                <CenterSearchMember>
                    <TextField
                        value={nombre}
                        onChange={handleName}
                        required
                        type="text"
                        variant="outlined"
                        color="primary"
                        placeholder={placeholder}
						style={{ width: '100%' }}
                    />
                </CenterSearchMember>
        </ContainerGroupsForm>
    );
};

export default GroupName;
